import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../../services/api';

export const fetchCurrentSession = createAsyncThunk(
  'session/fetchCurrent',
  async (_, { rejectWithValue }) => {
    try {
      const res = await apiService.getCurrentSession();
      return res.data;
    } catch (err) {
      // Pass full error body for session ownership conflict handling
      if (err.body?.code === 'SESSION_OWNERSHIP_CONFLICT') {
        return rejectWithValue({
          message: err.body.error,
          code: err.body.code,
          details: err.body.details,
          fullMessage: err.body.message,
        });
      }
      return rejectWithValue(err.body?.error || err.message);
    }
  }
);

export const openSession = createAsyncThunk(
  'session/open',
  async (body, { rejectWithValue }) => {
    try {
      const res = await apiService.openSession(body);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.body?.error || err.message);
    }
  }
);

export const closeSession = createAsyncThunk(
  'session/close',
  async (body, { rejectWithValue }) => {
    try {
      const res = await apiService.closeSession(body);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.body?.error || err.message);
    }
  }
);

const sessionSlice = createSlice({
  name: 'session',
  initialState: { current: null, loading: false, error: null, ownershipConflict: null },
  reducers: {
    clearSession: (state) => {
      state.current = null;
      state.error = null;
      state.ownershipConflict = null;
    },
    clearOwnershipConflict: (state) => {
      state.ownershipConflict = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCurrentSession.pending, (state) => { state.loading = true; state.error = null; state.ownershipConflict = null; })
      .addCase(fetchCurrentSession.fulfilled, (state, action) => { state.current = action.payload; state.loading = false; state.error = null; state.ownershipConflict = null; })
      .addCase(fetchCurrentSession.rejected, (state, action) => {
        state.loading = false;
        if (action.payload?.code === 'SESSION_OWNERSHIP_CONFLICT') {
          state.ownershipConflict = action.payload;
          state.error = null;
        } else {
          state.error = action.payload;
          state.ownershipConflict = null;
        }
      })
      .addCase(openSession.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(openSession.fulfilled, (state, action) => { state.current = action.payload; state.loading = false; state.error = null; })
      .addCase(openSession.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(closeSession.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(closeSession.fulfilled, (state) => { state.current = null; state.loading = false; state.error = null; })
      .addCase(closeSession.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
  },
});

export const { clearSession, clearOwnershipConflict } = sessionSlice.actions;
export default sessionSlice.reducer;
